module.exports = __webpack_public_path__ + "assets/img/ewm-gzh.f3978b70.png";